module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-3-adf50271e28af1cfd3b03ef5b1057497.webp";